var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditRowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1399 0.293677C13.944 0.0990267 13.627 0.0996624 13.432 0.295097L6.24641 7.49334C6.18658 7.55327 6.14299 7.62739 6.11973 7.70873L5.40674 10.2016C5.36355 10.3526 5.50383 10.492 5.655 10.4483L8.15055 9.72689C8.23198 9.70335 8.30609 9.65955 8.36592 9.59962L13.641 4.31521L11.5304 2.20459L12.2375 1.49749L14.3475 3.60748L15.5515 2.40138C15.7465 2.20594 15.7459 1.88972 15.55 1.69507L14.1399 0.293677Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V13.9C14 13.9552 13.9552 14 13.9 14H2.1C2.04477 14 2 13.9552 2 13.9V2.1C2 2.04477 2.04477 2 2.1 2H8",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRowIcon);
export default __webpack_public_path__ + "static/media/edit-row-icon.00889620a46d5419f40f5c616d2aa8ff.svg";
export { ForwardRef as ReactComponent };